import React, { Component } from 'react';

export default class DeckTile extends Component {
    changeURLPath = (newPath) => {
        const baseURL = window.location.origin;
        const params = window.location.search;
        const newURL = baseURL + newPath;
        if (params) {
            return newURL + params;
        }
        return newURL;
    }

    deckTileClick = () => {
        if (this.props.isThieme) {
            this.props.selectDeckForDetails(this.props.id)
        }
    }

    render() {
        let tileSrc;
        if (this.props.try) {
            tileSrc= './images/' + this.props.image;
        } else {
            tileSrc= './images/' + this.props.image;
        }
        return (
            <div className='deck-tile' onClick={this.deckTileClick}>
                <div className='deck-tile_img-wrapper'>
                    <img src={tileSrc} alt="Deck Tile" />
                    {this.props.isThieme && <img className="faded-thieme" src={'./images/thieme-faded.png'} alt="Thieme" />}
                </div>
                <div className='deck-tile_content'>
                    <div className='top'>
                        <h2>
                            {this.props.name}
                            {this.props.isThieme && <svg style={{ marginLeft: '.375rem'}} width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#5B61F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M12 16V12" stroke="#5B61F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                <path d="M12 8H12.01" stroke="#5B61F6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>}
                        </h2>
                        <div className='description'>
                            <div className='overflow-overlay overflow-overlay--top'></div>
                            <div className='inner'>
                                <div className='price-wrap'>
                                    {this.props.badge2 && <p><strong>{this.props.badge2}</strong><span>/ Month</span> |</p>}
                                    {this.props.badge && this.props.id !== 'topscore' && <p><strong>{this.props.badge}</strong><span>/ Year</span></p>}
                                    {this.props.id === 'topscore' && <p><strong>{this.props.badge}</strong><span>/ Year</span></p>}
                                </div>
                                <p>{this.props.description}</p>
                            </div>
                            <div className='overflow-overlay'></div>
                        </div>
                    </div>
                    <div className='buttons'>
                        {this.props.register && <a className="button" href={this.props.register} onClick={(e) => {e.stopPropagation();}}>Get Deck</a>}
                        {this.props.try && <a href={this.changeURLPath('/try/' + this.props.try)} className='button button--secondary' onClick={(e) => {e.stopPropagation();}}>Try</a>}
                    </div>
                </div>
            </div>
        );
    }
}